import styled from "styled-components";

export const Container = styled.section`
	.content {
		margin-bottom: 6em;

		button {
			width: 100%;
			max-width: 100%;
		}

		p {
			margin-bottom: 2em;
		}
		label {
			display: flex;
			flex-direction: column;
			margin-bottom: 1em;

			p {
				margin: 0;
				font-size: 16px;
			}

			input,
			select,
			textarea {
				width: 100%;
				border: 1px solid #b2b2b2;
				padding-left: 10px;
				height: 45px;
				line-height: 45px;

				&::placeholder {
					color: #c8c8c8;
				}
			}

			span.require {
				color: tomato;
				font-size: 14px;
				padding-top: 2px;
			}
		}
	}

	.separator {
		display: block;
		border-bottom: 2px solid var(--secundary-color);
		margin-bottom: 2em;
	}
`;

export const LabelContainer = styled.div`
	label {
		display: flex;
		flex-direction: column;
		row-gap: 5px;
		margin-bottom: 1em;

		span {
			font-size: 1em;
		}

		input {
			padding-left: 1em;
			height: 45px;
			border: 1px solid #d9d9d9;
		}

		span.require {
			color: tomato;
			font-size: 14px;
			padding-top: 2px;
		}

		p {
			margin: 0;
			font-size: 16px;
		}
	}
`;
